export enum RoundResult {
  UP = 'UP',
  DOWN = 'DOWN',
  DRAW = 'DRAW',
}
